import React from "react";
import { Button, Form, Icon } from "semantic-ui-react";

// Hooks
import useUpload from "@common/components/hooks/useUpload";
import useLogin from "@common/components/hooks/useLogin";
import UploadedImageList from "./UploadedImageList";

const UploadComponent = () => {
  const {
    fileInputRef,
    imageToUpload,
    setImageToUpload,
    progress,
    handleFileChange,
    handleButtonClick,
    handleUpload,
  } = useUpload();

  const [{ isInReadMode }] = useLogin();

  return (
    <div className="m-1">
      {!isInReadMode && (
        <>
          <div className="flex-row-center">
            <Form.Field>
              <Button
                type="button"
                content="Choose File"
                labelPosition="left"
                icon="file"
                onClick={handleButtonClick}
                disabled={progress !== 0}
              />
              <input
                ref={fileInputRef}
                type="file"
                hidden
                onChange={handleFileChange}
                accept="image/jpeg"
              />
              <Button
                type="button"
                disabled={
                  imageToUpload === null ||
                  (imageToUpload && imageToUpload.size > 20000000) ||
                  progress !== 0
                }
                onClick={handleUpload}
              >
                Upload
              </Button>
            </Form.Field>
          </div>
          <p
            className={`pt-0_5 mb-0 ${
              imageToUpload && imageToUpload.size > 20000000 && "warning-text"
            }`}
          >
            Maximum file size: 20MB
          </p>
          {imageToUpload && (
            <div className="py-1 flex-row-center">
              {progress === 0 && (
                <Icon
                  color="red"
                  size="large"
                  onClick={() => {
                    setImageToUpload(null);
                    fileInputRef.current.value = null;
                  }}
                  name="remove circle"
                />
              )}
              <div className="flex-row-center">
                <p className="pr-1 m-0">
                  <b>{imageToUpload.name}</b>
                </p>
                {progress > 0 && (
                  <progress value={progress} max="100"></progress>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <UploadedImageList />
    </div>
  );
};
export default UploadComponent;
